module.exports = __webpack_public_path__ + "static/media/purchasing1.fc425958.pdf";